import { render } from "./OrganizationAddOverlay.vue?vue&type=template&id=3cdaaeba&scoped=true&ts=true"
import script from "./OrganizationAddOverlay.vue?vue&type=script&lang=ts"
export * from "./OrganizationAddOverlay.vue?vue&type=script&lang=ts"

import "./OrganizationAddOverlay.vue?vue&type=style&index=0&id=3cdaaeba&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cdaaeba"]])

export default __exports__